import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import LinearProgress from '@mui/material/LinearProgress';
import Avatar from '@mui/material/Avatar';
import ButtonBase from '@mui/material/ButtonBase';
import PersonIcon from '@mui/icons-material/Person';
import { REPUTATION_COLORS, reputationProgress } from '../reputationUtils';

function CustomerStatusBar({ customer }) {
    const reputation = customer.reputation;
    const progress = reputationProgress(reputation);
    const progressColor = reputation && reputation.level ? REPUTATION_COLORS[reputation.level] : 'info';
    const progressText = reputation
        ? reputation.nextLevelThreshold
            ? `Completa ${reputation.salesNeededForNextLevel} ventas más para subir de nivel.`
            : `${reputation.levelLabel} · nivel máximo`
        : null;

    return (
        <Paper
            elevation={0}
            sx={{
                position: 'fixed',
                left: 0,
                right: 0,
                bottom: 0,
                borderRadius: 0,
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
                borderLeft: 'none',
                borderRight: 'none',
                borderBottom: 'none',
                zIndex: (theme) => theme.zIndex.appBar,
                px: { xs: 2, sm: 3 },
                pt: { xs: 1, sm: 1.5 },
                pb: { xs: 'calc(14px + env(safe-area-inset-bottom))', sm: 1.25 },
                maxWidth: 600,
                mx: 'auto',
                boxShadow: '0 -4px 24px rgba(15, 23, 42, 0.08)',
            }}
        >
            <Stack direction="row" alignItems="center" gap={{ xs: 1, sm: 1.5 }}>
                <ButtonBase
                    component={RouterLink}
                    to="/my-profile"
                    aria-label="Abrir mi perfil"
                    sx={{ borderRadius: '50%', flexShrink: 0 }}
                >
                    <Avatar
                        src={customer.equipped_avatar_url || undefined}
                        sx={{
                            bgcolor: 'primary.main',
                            color: 'primary.contrastText',
                            width: { xs: 34, sm: 40 },
                            height: { xs: 34, sm: 40 },
                        }}
                    >
                        {!customer.equipped_avatar_url && <PersonIcon fontSize="small" />}
                    </Avatar>
                </ButtonBase>
                <Box
                    component={RouterLink}
                    to="/my-profile"
                    sx={{ flexGrow: 1, minWidth: 0, textDecoration: 'none', color: 'inherit' }}
                >
                    <Stack direction="row" alignItems="baseline" justifyContent="space-between" gap={1}>
                        <Typography variant="subtitle1" fontWeight={700} noWrap>
                            {customer.username}
                        </Typography>
                        {reputation && (
                            <Typography
                                variant="caption"
                                color="text.secondary"
                                noWrap
                                sx={{ flexShrink: 0, display: { xs: 'none', sm: 'block' } }}
                            >
                                {progressText}
                            </Typography>
                        )}
                    </Stack>
                    {reputation && (
                        <LinearProgress
                            variant="determinate"
                            value={progress}
                            color={progressColor}
                            sx={{ height: 6, borderRadius: 3, mt: 0.5 }}
                        />
                    )}
                    {reputation && (
                        <Typography
                            variant="caption"
                            color="text.secondary"
                            noWrap
                            sx={{ display: { xs: 'block', sm: 'none' }, mt: 0.4 }}
                        >
                            {progressText}
                        </Typography>
                    )}
                </Box>
            </Stack>
        </Paper>
    );
}

export default CustomerStatusBar;
